module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/标签-作者.1bc11.png";